<template>
  <div class="org-page">
    <el-card v-loading="loading" class="info-card" shadow="never">
      <div class="card-head">
        <div class="head-left">
          <span class="head-icon"><i class="el-icon-office-building"></i></span>
          <div class="head-text">
            <div class="head-name">{{ info.name || '—' }}</div>
            <div class="head-sub">账号：{{ info.account }} · 状态：{{ statusText }}</div>
          </div>
        </div>
        <div v-if="info.expire_days !== null && info.expire_days !== undefined" class="head-expire" :class="{ 'expire-warn': info.expire_days <= 30 }">
          <span class="expire-label">服务到期</span>
          <span class="expire-date">{{ info.expire_date }}</span>
          <span class="expire-days">{{ info.expire_days }} 天</span>
        </div>
      </div>

      <el-divider />

      <div class="info-grid">
        <div class="info-item">
          <span class="info-label">机构全称</span>
          <span class="info-value">{{ info.name || '—' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">机构简称</span>
          <span class="info-value">{{ info.short_name || '—' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">联系人</span>
          <span class="info-value">{{ info.contact || '—' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">联系电话</span>
          <span class="info-value">{{ info.phone || '—' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">所在城市</span>
          <span class="info-value">{{ info.city || '—' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">详细地址</span>
          <span class="info-value">{{ info.address || '—' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">到期日期</span>
          <span class="info-value">{{ info.expire_date || '—' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">创建时间</span>
          <span class="info-value">{{ fmtDateTime(info.createtime) }}</span>
        </div>
      </div>

      <div class="action-row">
        <el-button type="primary" icon="el-icon-edit" @click="openEdit">编辑机构信息</el-button>
      </div>
    </el-card>

    <!-- 编辑弹窗 -->
    <el-dialog title="编辑机构信息" :visible.sync="editVisible" width="520px">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px" size="small">
        <el-form-item label="机构全称" prop="name">
          <el-input v-model="form.name" :maxlength="100" />
        </el-form-item>
        <el-form-item label="机构简称">
          <el-input v-model="form.short_name" :maxlength="50" />
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="form.contact" :maxlength="50" />
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="form.phone" :maxlength="20" />
        </el-form-item>
        <el-form-item label="所在城市">
          <el-input v-model="form.city" :maxlength="50" />
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input v-model="form.address" :maxlength="100" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="doSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { companyInfo, companyUpdate } from '@/api/company'

export default {
  name: 'OrgIndex',
  data() {
    return {
      info: {},
      loading: false,
      editVisible: false,
      saving: false,
      form: { name: '', short_name: '', contact: '', phone: '', city: '', address: '' },
      rules: {
        name: [{ required: true, message: '请填写机构全称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    statusText() {
      return parseInt(this.info.status) === 1 ? '正常' : '已停用'
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      companyInfo()
        .then(data => {
          this.info = data || {}
        })
        .catch(() => {})
        .finally(() => { this.loading = false })
    },
    openEdit() {
      this.form = {
        name: this.info.name || '',
        short_name: this.info.short_name || '',
        contact: this.info.contact || '',
        phone: this.info.phone || '',
        city: this.info.city || '',
        address: this.info.address || ''
      }
      this.editVisible = true
    },
    doSave() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        companyUpdate({
          name: this.form.name.trim(),
          short_name: (this.form.short_name || '').trim(),
          contact: (this.form.contact || '').trim(),
          phone: (this.form.phone || '').trim(),
          city: (this.form.city || '').trim(),
          address: (this.form.address || '').trim()
        })
          .then(() => {
            this.$message.success('保存成功')
            this.editVisible = false
            this.load()
          })
          .catch(() => {})
          .finally(() => { this.saving = false })
      })
    },
    fmtDateTime(ts) {
      if (!ts) return '—'
      const d = new Date(parseInt(ts) * 1000)
      const p = n => (n < 10 ? '0' + n : '' + n)
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    }
  }
}
</script>

<style scoped>
.org-page { max-width: 860px; margin: 0 auto; }

.info-card {
  border-radius: 12px;
  border: 1px solid #E5E9F2;
  padding: 8px 10px;
}

.card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 14px;
}

.head-left { display: flex; align-items: center; gap: 14px; }

.head-icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: linear-gradient(135deg, #3668FC, #5B8DFF);
  color: #FFF;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.head-name { font-size: 18px; font-weight: 700; color: #18233C; }
.head-sub { font-size: 12px; color: #8A94AD; margin-top: 4px; }

.head-expire {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #EDF3FE;
  border-radius: 8px;
  padding: 8px 14px;
}

.head-expire.expire-warn { background: #FEF3ED; }

.expire-label { font-size: 12px; color: #8A94AD; }
.expire-date { font-size: 13px; font-weight: 600; color: #18233C; }
.expire-days { font-size: 12px; color: #E8930C; font-weight: 600; }

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4px 24px;
}

@media (max-width: 640px) {
  .info-grid { grid-template-columns: 1fr; }
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 0;
  border-bottom: 1px solid #F2F4F8;
}

.info-label { font-size: 12px; color: #8A94AD; flex-shrink: 0; }
.info-value { font-size: 13px; color: #2B3653; text-align: right; word-break: break-all; }

.action-row { padding: 16px 0 8px; }

/* ===== Element UI 品牌色统一 ===== */
::v-deep .el-button--primary { background: #3668FC; border-color: #3668FC; }
::v-deep .el-button--primary:hover,
::v-deep .el-button--primary:focus { background: #5B8DFF; border-color: #5B8DFF; }
::v-deep .el-dialog { border-radius: 12px; }
</style>